import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { HStack, Image, Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const IntegrationExternalIdStack = ({
  integrations,
  resourceName,
  customExternalId = null,
  linkUrl = null,
  dataAnalyticsId = undefined
}) => {
  const externalId = useMemo(() => {
    if (!customExternalId && !integrations.length) {
      return '-';
    }

    const display = integrations.every(integration => integration.externalId !== customExternalId);

    if (!display) {
      return null;
    }

    if (display && customExternalId && integrations.length) {
      return `Custom: ${customExternalId}`;
    }

    return customExternalId;
  }, [customExternalId, integrations]);

  if (linkUrl) {
    return (
      <>
        {integrations
          .map(integration => {
            if (integration.thumbnailUrl) {
              return (
                <Tooltip key={integration[resourceName]} label={integration.integrationTypeName}>
                  <Link
                    data-analytics-id={dataAnalyticsId}
                    rel="noopener noreferrer"
                    target="_blank"
                    title={integration.externalId}
                    to={linkUrl}
                  >
                    <HStack my={2}>
                      <Image
                        alt="integration image"
                        height="20px"
                        objectFit="contain"
                        src={integration.thumbnailUrl}
                        width="20px"
                      />
                      <Text>{integration.externalId}</Text>
                    </HStack>
                  </Link>
                </Tooltip>
              );
            }

            return (
              <Text
                key={integration[resourceName]}
                textAlign="left"
              >
                {`${integration.integrationTypeName}: ${integration.externalId}`}
              </Text>
            );
          })}
        {externalId && (
          <Text textAlign="left">{externalId}</Text>
        )}
      </>
    );
  }

  return (
    <>
      {integrations
        .map(integration => {
          if (integration.thumbnailUrl) {
            return (
              <Tooltip key={integration[resourceName]} label={integration.integrationTypeName}>
                <HStack my={2}>
                  <Image
                    alt="integration image"
                    height="20px"
                    objectFit="contain"
                    src={integration.thumbnailUrl}
                    width="20px"
                  />
                  <Text>{integration.externalId}</Text>
                </HStack>
              </Tooltip>
            );
          }

          return (
            <Text
              key={integration[resourceName]}
              textAlign="left"
            >
              {`${integration.integrationTypeName}: ${integration.externalId}`}
            </Text>
          );
        })}
      {externalId && (
        <Text textAlign="left">{externalId}</Text>
      )}
    </>
  );
};

IntegrationExternalIdStack.propTypes = {
  integrations: PropTypes.arrayOf(PropTypes.shape({})),
  resourceName: PropTypes.string.isRequired,
  customExternalId: PropTypes.string,
  linkUrl: PropTypes.string,
  dataAnalyticsId: PropTypes.string
};

export default IntegrationExternalIdStack;
